import React from "react";
import "./Dot.scss";

const Dot = ({ color = "blue" }) => {
  return <span className={`dot dot--${color}`} />;
};

export default Dot;

